
import ResponsiveImage from 'components/Common/ResponsiveImage'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { TourV2ContentSections } from 'constants/tours'
import { useFormattedTourV2VariationDetailsCount } from 'hooks/TourV2/useTourV2VariationDetails'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'

const CardContent = styled.div``

const CardActions = styled.div``

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem(16)};
  gap: ${rem(8)};

  ${mediaQueryUp.sm} {
    padding: ${rem(24)};
    gap: ${rem(24)};
    flex-direction: row;
    align-items: center;

    > ${CardContent} {
      flex-grow: 1;
    }

    > ${CardActions} {
      flex-shrink: 0;
    }
  }
`

const CardImageContainer = styled.div`
  > * {
    height: 100%;
  }
`

const UnavailabilityCard = styled.div`
  display: flex;
  border: 1px solid ${props => props.theme.palette.neutral.five};
  background-color: ${props => props.theme.palette.neutral.eight};

  > ${CardImageContainer} {
    flex-basis: ${rem(230)};
  }

  > ${CardBody} {
    flex-grow: 1;
  }
`

interface Props {
  offerVariation: Tours.V2OfferVariation
  onScrollTo: (section: TourV2ContentSections) => void
}

function TourV2UnavailabilityCard(props: Props) {
  const { offerVariation, onScrollTo } = props
  const offerImage = offerVariation.images[0]
  const { variationDetailsCountText } = useFormattedTourV2VariationDetailsCount(offerVariation)

  const handleViewOfferDetails = useCallback(() => {
    onScrollTo(TourV2ContentSections.GALLERY)
  }, [onScrollTo])

  return <UnavailabilityCard>
    {!!offerImage && <CardImageContainer>
      <ResponsiveImage aspectRatio="5:3" id={offerImage.id} xsWidth="230px" fit="center" />
    </CardImageContainer>}
    <CardBody>
      <CardContent>
        <Heading variant="heading5">Sorry, {offerVariation.name} has sold out!</Heading>
        <BodyText variant="medium">
          {variationDetailsCountText}
        </BodyText>
      </CardContent>
      <CardActions>
        <TextLink size="medium" onClick={handleViewOfferDetails}>View offer details</TextLink>
      </CardActions>
    </CardBody>
  </UnavailabilityCard>
}

export default TourV2UnavailabilityCard
